import { Box } from '@mui/material';
import Tab from '@mui/material/Tab';
import { Fragment, useEffect } from 'react';
import Tabs from '/@/components/new-tabs';
import useUnitProvider from '/@/core/context/unit';
import settings from '/@/core/settings';
import { useFrostRiskMaps } from '/@/hooks/frost-risk';
import { _ } from '/@/locale';
import useWindowSize from '/@/utils/hooks/window-size';
import Select from '/@/v3/components/forms/select';
import Title from '/@/v3/components/title';
import { cardSx } from '..';
import FRReferences from '../components/references';

const FrostRiskMapOverlay = ({ onChangeMap, map, setIsLoading }) => {
    const { data: maps, isValidating } = useFrostRiskMaps();
    const isMobile = useWindowSize().width < 900;
    useEffect(() => {
        setIsLoading(isValidating);
    }, [isValidating]);

    useEffect(() => {
        if (!maps) return;
        if (maps.results && maps.results.length > 0) onChangeMap(maps.results[0]);
    }, [maps]);

    const units = useUnitProvider();

    const REFERENCES = [
        { label: _('Alto'), secondLabel: `<=${units.toTemperature(3, 0)}`, color: '#D33127' },
        { label: _('Alto-Medio'), secondLabel: `=${units.toTemperature(4, 0)}`, color: '#F7C44D' },
        { label: _('Medio'), secondLabel: `=${units.toTemperature(5, 0)}`, color: '#FFFC8F' },
        {
            label: _('Bajo'),
            secondLabel: `>${units.toTemperature(5, 0)} & <=${units.toTemperature(7, 0)}`,
            color: '#86F64C',
        },
        { label: _('Sin riesgo'), secondLabel: `>${units.toTemperature(7, 0)}`, color: '#337EED' },
    ];

    return (
        <Fragment>
            {maps && (
                <Box
                    sx={{
                        ...cardSx,
                        display: 'flex',
                        flexDirection: 'column',
                        width: { xs: 200, md: 350 },
                        alignItems: 'flex-start',
                        gap: 2,
                        p: 2,
                        zIndex: 1,
                        pointerEvents: 'auto',
                    }}
                >
                    <Title bolder size='md'>
                        {_('Periodo')}
                    </Title>
                    <Box sx={{ width: '100%' }}>
                        {isMobile ? (
                            <Select
                                value={map}
                                options={maps.results.map((map) => ({ label: _(map.duration), value: map }))}
                                clearable={false}
                                color={settings.app.theme}
                                onChange={(e) => onChangeMap(e)}
                                maxHeight='300px'
                                colorValue
                            />
                        ) : (
                            <Tabs
                                value={map}
                                onChange={(ev, v) => onChangeMap(v)}
                                textColor='primary'
                                indicatorColor='primary'
                                aria-label='tabs'
                                centered
                                sx={{ width: '100%' }}
                            >
                                {maps.results.map((m, i) => {
                                    return (
                                        <Tab
                                            key={`${m.id}-${i}`}
                                            sx={{
                                                fontSize: 16,
                                                ...(map && m && m.duration !== map.duration && { color: 'lightgray' }),
                                            }}
                                            value={m}
                                            label={_(m.duration)}
                                            wrapped
                                        />
                                    );
                                })}
                            </Tabs>
                        )}
                    </Box>
                </Box>
            )}
            <Box sx={{ position: 'absolute', bottom: '76px', width: '100%', pointerEvents: 'none' }}>
                <FRReferences
                    references={REFERENCES}
                    title={_('Riesgo de helada (temperatura mínima)')}
                    sx={{
                        flexDirection: 'column',
                        width: { xs: 200, md: 350 },
                        alignItems: 'flex-start',
                        pointerEvents: 'auto',
                    }}
                />
            </Box>
        </Fragment>
    );
};

export default FrostRiskMapOverlay;
